// Elige SOLO el crédito vigente para MovilesPay.
// Vigente = no finalizado (fr_state_filter != 4), enrolado (fr_payment_state = 1) y activo (fr_state = 1).
// Si no hay vigente => retorna null (NO autocompletar).
// Solo crédito vigente para MovilesPay.
// Si el payload NO trae fr_state_filter / fr_payment_state / fr_state,
// asumimos que el backend ya filtró y retornamos el primer registro.
export const pickActiveCredit = (payload) => {
    // Normaliza a lista
    const list = (() => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        if (Array.isArray(payload?.data)) return payload.data;
        if (payload?.data && typeof payload.data === "object") return [payload.data];
        if (Array.isArray(payload?.credit)) return payload.credit;
        if (payload?.credit && typeof payload.credit === "object") return [payload.credit];
        if (typeof payload === "object" && payload.fr_dni) return [payload];
        return [];
    })();

    if (list.length === 0) return null;

    // ¿Vienen los campos de estado?
    const hasState = ["fr_state_filter", "fr_payment_state", "fr_state"].every(
        (k) => Object.prototype.hasOwnProperty.call(list[0] || {}, k)
    );

    if (hasState) {
        // Filtro estricto en el cliente
        return (
            list.find(
                (c) =>
                    Number(c.fr_state_filter) !== 4 &&
                    Number(c.fr_payment_state) === 1 &&
                    Number(c.fr_state) === 1
            ) || null
        );
    }

    // Sin campos de estado => confiar en el backend: tomar el primero
    return list[0];
};

// Helpers para agrupar sedes por primera palabra
const firstWord = (s = "") => String(s).trim().split(/\s+/)[0] || "";
const restWords = (s = "") => String(s).trim().split(/\s+/).slice(1).join(" ").trim();

export const buildGroupedSedesOptions = (sedes = [], totalEquiposNum = 0) => {
    // Opción "Todos"
    const allSedes = { value: 0, label: `Todos (${totalEquiposNum})` };

    // Agrupar por ciudad
    const groupsMap = new Map();

    for (const sede of sedes) {
        const full = sede.sede || "";
        const city = firstWord(full);                 // Iquitos / Pucallpa / Tarapoto
        const childName = restWords(full) || full;    // "S. Lores" / "Km. 6" / etc.

        if (!groupsMap.has(city)) {
            groupsMap.set(city, {
                label: city,
                total: 0,
                options: [],
            });
        }

        const g = groupsMap.get(city);
        const count = Number(sede.countRegister || 0);

        g.total += count;
        g.options.push({
            value: sede.idNumber,
            // HIJO: "S. Lores (2)"
            label: `${childName} (${count})`,
            // guardamos estos por si luego los necesitas
            __city: city,
            __childName: childName,
            __count: count,
        });
    }

    // Orden: por total desc (opcional) y luego alfabético
    const grouped = Array.from(groupsMap.values())
        .sort((a, b) => (b.total - a.total) || a.label.localeCompare(b.label))
        .map((g) => ({
            // react-select group object
            label: g.label,
            total: g.total,          // <-- extra para el heading
            options: g.options.sort((a, b) => (b.__count - a.__count) || a.__childName.localeCompare(b.__childName)),
        }));

    // "Todos" arriba + grupos
    return [...grouped, allSedes];
}

